import { render, staticRenderFns } from "./DouYinProductRelease.vue?vue&type=template&id=7fcd2cb1&scoped=true"
import script from "./DouYinProductRelease.vue?vue&type=script&lang=js"
export * from "./DouYinProductRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcd2cb1",
  null
  
)

export default component.exports